import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../../../../helpers/reducerRegistry'
import { convertDataCreditChartRiskScore } from '../../../../../../../../../../helpers/score'
import { TYPE_CHART_RISK } from '../constant'
import { convertDataChartDistribution } from '../helper'
import { getDistributionScore, getTrendOfScore } from './thunk'

const initialState = {
  loading: {
    trendOfScore: true,
    distributionScore: true,
  },
  dataChartTrendOfScore: [],
  dataChartDistribution: {
    industry: [],
    region: [],
    year: [],
  },
  typeRadioDynamic: 'industry',
  listScoreCreditDynamic: TYPE_CHART_RISK.map((item) => item.dataKey),
}

const slice = createSlice({
  name: 'companyAnalysis/companyScore/creditRiskScore/chart',
  initialState: initialState,
  reducers: {
    resetStoreCreditScoreChart: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTypeRadioDynamicCredit: (state, action) => {
      state.typeRadioDynamic = action.payload
    },
    changeListSelectDynamicCredit: (state, action) => {
      state.listScoreCreditDynamic = action.payload
    },
  },
  extraReducers: (builder) => {
    //get getTrendOfScore
    builder.addCase(getTrendOfScore.pending, (state) => {
      state.loading.trendOfScore = true
    })
    builder.addCase(getTrendOfScore.fulfilled, (state, action) => {
      state.dataChartTrendOfScore = convertDataCreditChartRiskScore(
        action.payload,
        action.meta.arg['TimeFrequency'],
      )
      state.loading.trendOfScore = false
    })
    builder.addCase(getTrendOfScore.rejected, (state, action) => {
      state.dataChartTrendOfScore = initialState['dataChartTrendOfScore']
      state.loading.trendOfScore = action.payload.loading
    })

    //getDistributionScore
    builder.addCase(getDistributionScore.pending, (state) => {
      state.loading.distributionScore = true
    })
    builder.addCase(getDistributionScore.fulfilled, (state, action) => {
      state.dataChartDistribution = convertDataChartDistribution(action.payload)
      state.loading.distributionScore = false
    })
    builder.addCase(getDistributionScore.rejected, (state, action) => {
      state.dataChartDistribution = initialState['dataChartDistribution']
      state.loading.distributionScore = action.payload.loading
    })
  },
})
//trend Score Chart
export const selectChartTrendOfScore = (state) =>
  state[slice.name].dataChartTrendOfScore
//distribution Chart
export const selectChartDistribution = (type) => (state) =>
  state[slice.name].dataChartDistribution[type]

//getLoading
export const getLoadingChartCredit = (type) => (state) =>
  state[slice.name].loading[type]

//select for Dynamic
export const selectTypeRadioDynamicCredit = (state) =>
  state[slice.name].typeRadioDynamic
export const selectListCheckDynamicCredit = (state) =>
  state[slice.name].listScoreCreditDynamic

export const {
  resetStoreCreditScoreChart,
  changeTypeRadioDynamicCredit,
  changeListSelectDynamicCredit,
} = slice.actions
register(slice.name, slice.reducer)
